<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['add-website-title']"
    :description="propsdata[0]['translation']['add-website-description']"
/>

<div class="sc-kEYyzF grKTOC">
  <section class="section section-lg pt-0" style="padding-bottom: 8rem;">
     <div class="container" style="padding-top: 10rem;">
        <div class="row justify-content-center mb-5 mb-lg-6">
           <div class="col-md-6 text-center">
              <h2 class="h1 mb-3">{{propsdata[0]['translation']['add-website-url']}}</h2>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-link"></i></span>
                </div>
                <input v-model="website" :placeholder="propsdata[0]['translation']['add-website-example-placeholder']" type="url" name="website" class="form-control">
              </div>
              <br>
              <a v-if="!saving" @click="Next" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;padding: 8px 12px 8px 12px;">{{propsdata[0]['translation']['add-website-continue']}} <i class="fas fa-arrow-right" style="margin-right: 6px;margin-left: 8px;"></i></a>
              <a v-if="saving" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;padding: 8px 12px 8px 12px;">{{propsdata[0]['translation']['add-website-saving']}} <i class="fas fa-spinner" style="margin-right: 6px;margin-left: 8px;"></i></a>
              <p :style="{visibility: website === '' && error ? 'visible' : 'hidden', position: website === '' && error ? 'initial' : 'absolute'}" class="small" style="color: rgb(237, 80, 79);visibility: hidden;margin-top: 20px;">{{propsdata[0]['translation']['add-website-required']}}</p>
            </div>
        </div>
      </div>
    </section>
  </div>


</div>

</template>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        website: '',
        error: false,
        saving: false
      };
    },
    methods: {
      Next(){
        if(this.website == ''){
          this.error = true;
        }
        else{
          this.Save();
          this.error = false;
        }
      },
      Save(){
        if(!this.saving){
          this.saving = true;
          axios.post('/dashboard/enviar-website.php', {
            website: this.website
            })
            .then(response => {
              this.saving = false;
              window.location.replace("https://termify.io/dashboard/edit-website/"+response.data);
          })
            .catch(function (error) {
              console.log(error);
            });
          }
      }
    },
    mounted() {
    }
  };
  </script>



// WEBPACK FOOTER //
// src/add-website.vue